import { render } from "./agregarAsignacion.vue?vue&type=template&id=2dc70f9f&scoped=true"
import script from "./agregarAsignacion.vue?vue&type=script&lang=js"
export * from "./agregarAsignacion.vue?vue&type=script&lang=js"

import "./agregarAsignacion.vue?vue&type=style&index=0&id=2dc70f9f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc70f9f"]])

export default __exports__